import React, { Component } from "react";
import { connect } from "react-redux";
import { usrRole } from "../../utils/dataUtil";
import {
  req_list_cslc_private_works,
  req_edit_cslc_myparticipant,
  req_list_cslc_public_activity,
} from "../../api";

import { DEFAULT_IMAGE_URL } from "../../utils/contrains";
import { Tag, Image, Collapse, BackTop, message, Modal } from "antd";
import "./jury-all-works-list.css";
import storageUtils from "../../utils/storageUtils";

const { Panel } = Collapse;

class ManagerSetFinishScoreList extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    enrollCode: "",
    checkCount: 0,
    voteActivity: "2022-1001-00001",
    voters: 0,
    votes: 0,
  };

  componentDidMount() {
    this.api_check_activity();
    this.api_list_items();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { role } = this.props.user;
    const { enrollCode } = this.state;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_list_cslc_private_works(
      enrollCode,
      storageUtils.getUser().token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { data } = result;
      const items = data;

      this.setState({ items });
      // console.log(items);
    } else {
      const items = [];
      this.setState({ items });
    }
  };

  api_edit_item = async (item) => {
    await req_edit_cslc_myparticipant(item, storageUtils.getUser().token);
  };

  api_check_activity = async () => {
    const { voteActivity } = this.state;
    const result = await req_list_cslc_public_activity(voteActivity);

    //console.log(result)
    if (result.total > 0) {
      const { data } = result;
      this.setState({
        voters: this.toThousands(data[0].VotersTotal),
        votes: this.toThousands(data[0].VotesTotal),
      });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////

  handle_data_refresh = () => {
    this.api_list_items();
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "VIEW":
        this.setState({ isPdfWorkModal: true, item });
        break;
      case "PRINT":
        this.setState({ isPrintWorkModal: true, item });
        break;
      case "download":
        break;
      default:
    }
  };

  handle_choice_item = (itemKey, field, value) => {
    const { items } = this.state;

    // console.log("Uid", Uid);
    const objIndex = items.findIndex((obj) => obj.Uid === itemKey);
    const newValue = value || 0;
    items[objIndex][field] = newValue;
    // A.改變狀態
    this.setState(items);
    // B.回存數據
  };

  handle_data_selected = () => {
    const { items } = this.state;
    const { userCode, userName } = this.props.user;
    var count = 0;
    const selectedList = [];

    items.forEach(function (item) {
      if (item.VoterChoiceStatus === "YES") {
        count = count + 1;
        const obj = {
          VoterId: userCode,
          VoterName: userName,
          WorksId: item.WorksId,
          SelectedCode: item.EnrollCode,
        };
        selectedList.push(obj);
      }
    });

    if (count === 0) {
      message.error("您未選擇任一作品");
    } else if (count > 3) {
      message.error("您所選擇的數量超出規定");
    } else {
      Modal.confirm({
        title: `您確定投給這${count}項作品，送出後不得再改及重選`,
        onOk: () => {
          //console.log(selectedList);
          this.api_save_items(selectedList);
        },
      });
      // console.log(count);
      console.log(selectedList);
    }
  };

  handle_ui_field_change = (
    target_key,
    jury_score,
    vote_score,
    target_field,
    e
  ) => {
    var totalScore = 0.0;

    if (target_field === "VoteFinalScore") {
      let value = e.target.value;
      let voteFinalScore = parseFloat(Math.ceil(value), 10) || 0;
      let newVoteScore = parseFloat(voteFinalScore * 0.7, 10);
      totalScore = parseFloat(newVoteScore, 10) + parseFloat(jury_score, 10);
      // 前台更新
      this.handle_choice_item(target_key, "VoteFinalScore", voteFinalScore);
      this.handle_choice_item(target_key, "VoteScore", newVoteScore.toFixed(1));
      this.handle_choice_item(target_key, "TotalScore", totalScore.toFixed(1));
      // 後台更新
      //ProfessionalScore;
      const item = {
        condition: "SETVOTESCORE",
        Uid: target_key,
        voteFinalScore: voteFinalScore,
      };
      this.api_edit_item(item);
    } else if (target_field === "ProfessionalScore") {
      let value = e.target.value;
      let professionalScore = parseFloat(Math.ceil(value), 10) || 0;
      let newJuryScore = parseFloat(professionalScore * 0.3, 10);
      totalScore = parseFloat(newJuryScore, 10) + parseFloat(vote_score, 10);
      // 前台更新
      this.handle_choice_item(
        target_key,
        "ProfessionalScore",
        professionalScore
      );
      this.handle_choice_item(target_key, "JuryScore", newJuryScore.toFixed(1));
      this.handle_choice_item(target_key, "TotalScore", totalScore.toFixed(1));
      // 後台更新
      //ProfessionalScore;
      const item = {
        condition: "SETJURYSCORE",
        Uid: target_key,
        ProfessionalScore: professionalScore,
      };
      this.api_edit_item(item);
    }
  };

  handle_select_change = (item, e) => {
    const { Uid } = item;
    const obj = {
      condition: "RANKING",
      Uid: Uid,
      Ranking: e.target.value.trim(),
    };
    this.api_edit_item(obj);
  };

  style_switch_color_tag(column, type) {
    let ans = "black";
    switch (type) {
      case "awardlevel":
        switch (column) {
          case 0:
            ans = "#FDC904";
            break;
          case 1:
            ans = "#9a9a9a";
            break;
          case 2:
            ans = "#8E3F07";
            break;
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
            ans = "#D9FC96";
            break;
          default:
            // OTHER
            ans = "	White";
            break;
        }
        break;
      default:
        ans = "black";
        break;
    }
    return ans;
  }

  toThousands = (num) => {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading, items, voters, votes } = this.state;
    return (
      <>
        {loading ? (
          <div className="container">
            <div className="text-center">
              <button
                className="btn btn-light text-dark"
                type="button"
                disabled
              >
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                ></span>{" "}
                查詢中 ......
              </button>
            </div>
          </div>
        ) : (
          <>
            {items.length > 0 ? (
              <>
                {" "}
                <div
                  style={{
                    width: "100%",
                    backgroundColor: "#581845",
                    marginBottom: "5px",
                    color: "white",
                    padding: "5px",
                    fontSize: "1.5em",
                  }}
                >
                  共有
                  <em
                    style={{
                      color: "orange",
                      fontSize: "1.6em",
                      margin: "0 5px",
                    }}
                  >
                    {voters}
                  </em>
                  人參與，累計投出
                  <em
                    style={{
                      color: "orange",
                      fontSize: "1.6em",
                      margin: "0 5px",
                    }}
                  >
                    {votes}
                  </em>
                  張票
                </div>
                <div className="container">
                  <div className="row">
                    {items.map((item, index) => {
                      return (
                        <div
                          className="col-md-3"
                          key={index}
                          style={{ marginBottom: "6px" }}
                        >
                          <div className="thumbnail colstyle" key={index}>
                            <div className="caption">
                              <Collapse accordion defaultActiveKey={["1"]}>
                                <Panel header="票選情況" key="1">
                                  <div
                                    style={{
                                      fontSize: "1.2em",
                                      textAlign: "center",
                                    }}
                                  >
                                    <i
                                      className="fas fa-award"
                                      style={{
                                        color: this.style_switch_color_tag(
                                          index,
                                          "awardlevel"
                                        ),
                                        fontSize: "1.6em",
                                      }}
                                    ></i>
                                    <span>
                                      {" "}
                                      編號：
                                      <strong
                                        style={{
                                          color: "blue",
                                          fontSize: "1.4em",
                                        }}
                                      >
                                        {item.WorksCode}{" "}
                                      </strong>
                                      / {item.EnrollName}
                                    </span>
                                    <br />
                                    <span>
                                      獲得票數計：
                                      <em
                                        style={{
                                          color: "red",
                                          fontSize: "1.4em",
                                        }}
                                      >
                                        {item.GetVoteTotal}
                                      </em>{" "}
                                      張
                                    </span>
                                  </div>
                                </Panel>
                              </Collapse>
                            </div>
                            <div style={{ textAlign: "center" }}>
                              <Image
                                width={"250px"}
                                height={"150px"}
                                src={DEFAULT_IMAGE_URL + item.AttachedfileA}
                              />
                            </div>
                          </div>
                          <div
                            className="titleMame"
                            style={{ backgroundColor: "#320A5C" }}
                          >
                            <div style={{ textAlign: "right", margin: "auto" }}>
                              <p>
                                票換算
                                <input
                                  type="number"
                                  style={{ width: "60px", color: "blue" }}
                                  defaultValue={item.VoteFinalScore}
                                  onChange={(e) =>
                                    this.handle_ui_field_change(
                                      item.Uid,
                                      item.JuryScore,
                                      item.VoteScore,
                                      "VoteFinalScore",
                                      e
                                    )
                                  }
                                />
                                X0.7，得 {item.VoteScore} 分
                              </p>
                              <p>
                                評委加
                                <input
                                  type="number"
                                  style={{ width: "60px", color: "blue" }}
                                  defaultValue={item.ProfessionalScore}
                                  onChange={(e) =>
                                    this.handle_ui_field_change(
                                      item.Uid,
                                      item.JuryScore,
                                      item.VoteScore,
                                      "ProfessionalScore",
                                      e
                                    )
                                  }
                                />
                                X0.3，得 {item.JuryScore} 分
                              </p>
                              <p>
                                合計：
                                <span
                                  style={{
                                    fontSize: "1.6em",
                                    color: "yellow",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {item.TotalScore}
                                </span>{" "}
                                分
                              </p>
                              <div>
                                <select
                                  id="Ranking"
                                  defaultValue={item.Ranking}
                                  onChange={(value) =>
                                    this.handle_select_change(item, value)
                                  }
                                  key={index}
                                  style={{ width: "100%", color: "red" }}
                                >
                                  <option value="">未得名</option>
                                  <option value="第一名">第一名</option>
                                  <option value="第二名">第二名</option>
                                  <option value="第三名">第三名</option>
                                  <option value="第四名">第四名</option>
                                  <option value="第五名">第五名</option>
                                  <option value="佳作">佳作</option>
                                </select>
                              </div>
                              <div>
                                <Tag color="red">
                                  請自選出第一名，才能進行 [慧眼獨具獎]抽獎
                                </Tag>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <BackTop>
                  <div className="goTop">UP</div>
                </BackTop>
              </>
            ) : (
              <Tag color="blue" style={{ margin: "10px" }}>
                尚未開放投票(或無相關作品)
              </Tag>
            )}
          </>
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ManagerSetFinishScoreList);
